export const AMS_TAB_LABEL = "ams";

export function getHash(key) {
  const hash = window.location.hash.substring(1);
  const params = new URLSearchParams(hash);
  return params.get(key) || undefined;
}

export function setHash(key, value) {
  const hash = window.location.hash.substring(1);
  const params = new URLSearchParams(hash);
  params.set(key, value);
  window.location.hash = params.toString();
}
